import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Building2, HardHat, Loader2 } from "lucide-react";
import { toast } from "sonner";

const CRIMSON = "#bf3b4f";

export function PersonaToggle({ variant = "light", compact = false }) {
  const { user, isDual, switchPersona } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!isDual) return null;

  const current = user?.role === "Support Worker" ? "worker" : "office";
  const dark = variant === "dark";

  const go = async (p) => {
    if (p === current || busy) return;
    setBusy(true);
    try {
      const u = await switchPersona(p);
      toast.success(`Switched to ${p === "worker" ? "Support Worker" : "Office"} view`);
      nav(u.role === "Support Worker" ? "/worker" : "/");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't switch view. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const items = [
    { key: "office", label: "Office", icon: Building2 },
    { key: "worker", label: "Worker", icon: HardHat },
  ];

  return (
    <div data-testid="persona-toggle"
      className={`inline-flex items-center rounded-full p-0.5 ${dark ? "bg-white/15" : "bg-slate-100"}`}>
      {items.map((it) => {
        const active = it.key === current;
        const activeCls = dark ? "bg-white shadow-sm" : "text-white shadow-sm";
        return (
          <button
            key={it.key}
            type="button"
            onClick={() => go(it.key)}
            disabled={busy}
            data-testid={`persona-toggle-${it.key}`}
            title={`${it.label} view`}
            className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold transition-colors disabled:opacity-70 ${
              active ? activeCls : dark ? "text-white/75 hover:text-white" : "text-slate-500 hover:text-slate-800"
            }`}
            style={active ? (dark ? { color: CRIMSON } : { backgroundColor: CRIMSON }) : undefined}
          >
            {busy && active ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <it.icon className="h-3.5 w-3.5" />}
            {!compact && <span>{it.label}</span>}
          </button>
        );
      })}
    </div>
  );
}
